import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to the section referenced in the URL hash once the page is mounted.
 */
export function useHashScroll() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const id = hash.replace("#", "");
    const timer = window.setTimeout(() => {
      const target = document.getElementById(id);
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 140);

    return () => window.clearTimeout(timer);
  }, [hash, pathname]);
}